module.exports = __webpack_public_path__ + "CU.png?9b6e992305f628a8f83bb1384ef02b51";